export default __webpack_public_path__ + "static/media/ed-harris.b382249c.jpg";